<h2 mat-dialog-title>
  {{ input | translateInputValue: 'name' }}
  <button mat-icon-button mat-dialog-close tabindex="-1"><mat-icon>close</mat-icon></button>
</h2>
<mat-dialog-content>
  <div class="content">
    <div class="block padding ck-content" [innerHTML]="input | translateInputValue: 'message'"></div>
  </div>
</mat-dialog-content>
